import { useMemo } from 'react';
import { useAgentRunContext } from '../context/AgentRunContext';

export function useAgentRun() {
  const { state, sendMessage, resolveHitl, clearTimeline } = useAgentRunContext();

  const latestAssistantMessage = useMemo(
    () => [...state.messages].reverse().find((message) => message.role === 'assistant'),
    [state.messages]
  );

  const confidence = latestAssistantMessage?.answer?.confidence;
  const toolsUsed = latestAssistantMessage?.answer?.tools_used || [];
  const evidence = latestAssistantMessage?.answer?.evidence || [];

  return {
    state,
    sendMessage,
    resolveHitl,
    clearTimeline,
    latestAssistantMessage,
    confidence,
    toolsUsed,
    evidence,
  };
}
